module.exports = __webpack_public_path__ + "static/media/Whipple-Estates.5865a242.pdf";